import { type UsePaginatedListProps, usePaginatedList } from '../Pagination';
import { type UseSortableItemsProps, useSortableItems } from './useSortableItems';

export type UseStaticDataTableProps<Item extends object> = UseSortableItemsProps<Item> &
    UsePaginatedListProps<Item>;

/**
 * Hook to create a static items collection with sorting and pagination.
 */
export function useStaticDataTable<Item extends object>(props: UseStaticDataTableProps<Item>) {
    const { sortedItems, onSortChange, sortDescriptor } = useSortableItems(props);
    const { paginationProps, items } = usePaginatedList({
        items: sortedItems,
        itemsPerPage: props.itemsPerPage ?? 10,
    });

    return {
        dataTableProps: {
            items,
            onSortChange,
            sortDescriptor,
            columns: props.columns,
        },
        paginationProps,
    };
}
